import { render } from "./BuildAnything.vue?vue&type=template&id=ef74c97e"
import script from "./BuildAnything.vue?vue&type=script&lang=ts"
export * from "./BuildAnything.vue?vue&type=script&lang=ts"
script.render = render

export default script